import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import arrowImage from '~/static/images/arrow.svg';

export const Ask = styled.div<{ isOpen?: boolean }>`
    ${FONTS.MediumXS};
    cursor: pointer;
    flex-wrap: nowrap;
    color: ${COLORS.Link};
    margin-bottom: 16px;
    
    &::after{
        background-color: ${COLORS.Link};
        mask: url(${arrowImage}) no-repeat  50% 50%;
        content: '';
        width: 15px;
        height: 15px;
        margin: 4px 8px;
        background-size: cover;
        transition: 0.25s;
        transform: ${props => props.isOpen ? 'rotate(270deg)' : 'rotate(90deg)'};
    }
`;

export const ImageBlock = styled(LazyLoadImage)<{ src: string }>`
    width: 100%;
    background-size: cover;
`;

export const PopupInner = styled.div`
    padding: 32px;
    flex-direction: column;
`;

export const PopupTitle = styled.div`
    ${FONTS.H4}
    margin-bottom: 8px;
`;

export const TextBlock = styled.div`
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 8px;

    svg {
        max-width: 24px;
        width: 100%;

        #contour {
            > path {
                fill: ${COLORS.Brand_Blue};
            }
        }

        #guts {
            > path {
                fill: ${COLORS.BgMain};
            }
        }
    }
`;

export const PopupText = styled.p`
    ${FONTS.XS};
    margin-bottom: 16px;
    margin-left: 8px;
`;

export const BenefitsTextBlock = styled.div`
    display: flex;
    margin-bottom: 16px;
    gap: 16px;
`;

export const BenefitsText = styled.div`
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;

    svg {
        max-width: 24px;
        width: 100%;
    }
`;

export const StyledButton = styled(Button)`
    width: max-content;
    align-items: center;
    width: 100%;
`;

export const TextValue = styled.div`
    ${FONTS.XS};
    margin-left: 8px;
`;
